module.exports = __webpack_public_path__ + "img/lancome_create_game.db46062f.svg";